import { startOfDay } from 'date-fns';
import { transactionsToCashflows } from '@foresightdata/metrics-calculator';
import { KPI_COMPONENTS, Kpi, KpiCalculationParams, KpiConfig, KpiConfigMeta } from '../../../../types';
import { calculatePoolIrr } from '../../providers/calculatePoolIrr';
import { format } from './kpi-formatter';

export class IrrKpiConfig implements KpiConfig {
  private id = KPI_COMPONENTS.IRR as const;
  private title = 'Gross IRR';
  private type = 'percentage';

  getMeta(): KpiConfigMeta {
    return {
      id: this.id,
      title: this.title,
      type: this.type,
    };
  }

  calculate({ data }: KpiCalculationParams): Kpi {
    const cashflows = transactionsToCashflows(data?.metrics.flatMap((metric) => metric.transactions) ?? []);

    const fmv =
      data?.metrics?.reduce((sum, curr) => {
        return sum + (curr.fmv ?? 0);
      }, 0) ?? 0;

    const value = calculatePoolIrr(cashflows, fmv, startOfDay(data?.date ?? new Date())) ?? Number.NaN;
    return {
      ...this.getMeta(),
      value,
      formatted: format(value, this.type),
    };
  }
}
